import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoHlsComponent } from './video-hls.component';

@NgModule({
    declarations: [
        VideoHlsComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        VideoHlsComponent
    ]
})
export class NcVideoHlsModule { }